import {UseDelete, UsePut} from "../../hooks/http";

export const fetchEnterprises = async (id) => {
    const params = {data: {limit: 999, offset: 0}};

    if(id) {
        params.data._id = id;
        params.data.limit = 1;
    }

    const response = await UsePut(`/enterprises/get`, params)
    return id ? response?.entities[0] : response?.entities || [];
}




export const fetchSenders = async (id_domain) => {
    const response = await UsePut(
        `/senders/get`,
        {data: {offset: 0, id_domain: id_domain}}
    )
    return response?.entities || [];
}


export const fetchDomains = async (id_enterprise, id_domain) => {
    const params = {data: {limit: 999, offset: 0, id_enterprise: id_enterprise, mail_ready: true}};

    if(id_domain) {
        params.data._id = id_domain;
        params.data.limit = 1;
        delete params.data.mail_ready;
    }

    const response = await UsePut(`/domains/get`, params)
    return id_domain ? response?.entities[0] : response?.entities || [];
}


export const deleteSender = async (id_sender, onSuccess) => {
    await UseDelete(
        `/senders/delete`,
        {data: {idx: [id_sender]}, onSuccess: onSuccess}
    )
}